/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_PromotedInputs */

const cs_property_ai_promoted = /** @type {(inputs: Property_Ai_PromotedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidáno do veřejných fotek`)
};

const en_property_ai_promoted = /** @type {(inputs: Property_Ai_PromotedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Added to public photos`)
};

/**
* | output |
* | --- |
* | "Added to public photos" |
*
* @param {Property_Ai_PromotedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_promoted = /** @type {((inputs?: Property_Ai_PromotedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_PromotedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_promoted(inputs)
	return cs_property_ai_promoted(inputs)
});